// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Opaque byte string value.
 */
export class ByteString implements flatbuffers.IUnpackableObject<ByteStringT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ByteString {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsByteString(bb: flatbuffers.ByteBuffer, obj?: ByteString): ByteString {
    return (obj || new ByteString()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsByteString(bb: flatbuffers.ByteBuffer, obj?: ByteString): ByteString {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ByteString()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  valueLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  valueArray(): Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return new Uint8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  static startByteString(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, valueOffset, 0);
  }

  static createValueVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startValueVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static endByteString(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // value
    return offset;
  }

  static createByteString(
    builder: flatbuffers.Builder,
    valueOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ByteString.startByteString(builder);
    ByteString.addValue(builder, valueOffset);
    return ByteString.endByteString(builder);
  }

  unpack(): ByteStringT {
    return new ByteStringT(
      this.bb!.createScalarList<number>(this.value.bind(this), this.valueLength()),
    );
  }

  unpackTo(_o: ByteStringT): void {
    _o.value = this.bb!.createScalarList<number>(this.value.bind(this), this.valueLength());
  }

  unpackFields(...fields: string[]): ByteStringT {
    const t = new ByteStringT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.bb!.createScalarList<number>(this.value.bind(this), this.valueLength());
    }
    return t;
  }
}

export class ByteStringT implements flatbuffers.IGeneratedObject {
  constructor(public value: number[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const value = ByteString.createValueVector(builder, this.value);

    return ByteString.createByteString(builder, value);
  }

  clone(): ByteStringT {
    const obj = new ByteStringT();
    obj.value = [...this.value];
    return obj;
  }

  equals(other: ByteStringT): boolean {
    if (this.value.length !== other.value.length) return false;
    for (let i = 0; i < this.value.length; i++) {
      if (this.value[i] !== other.value[i]) return false;
    }
    return true;
  }
}

export function verifyByteString(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "value");
  } finally {
    verifier.popDepth();
  }
}
